import { useEffect, useState } from 'react'
import Default from 'components/layouts/Default/Default';
import ContactUsPage from 'components/templates/ContactUs/ContactUsPage';
import {
  useAppDispatch,
  useAppSelector,
} from 'app/hooks';
import {
  getContactUsData,
  selectContactUs,
} from 'features/contactus/contactUsSlice';

const ContactUs = () => {
  const dispatch = useAppDispatch();
  const {
    data, 
    pending, 
  } = useAppSelector(selectContactUs);

  const [contactusData, setContactUsData] = useState({})

  useEffect(() => {
    dispatch(getContactUsData())
    // getContactUs()
  }, [])
  return (
    <Default>
      <ContactUsPage data={data} />
    </Default>
  )
}
export default (ContactUs);